<template>
    <div>
        <div class="sm:hidden">
            <label for="tabs" class="sr-only">Select a tab</label>
            <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
            <select id="tabs" name="tabs" class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-light-pitch-purple sm:text-sm rounded-md">
                <option v-for="tab in tabs" :key="tab.name" :selected="tab.current">{{ tab.name }}</option>
            </select>
        </div>
        <div class="hidden sm:block">
            <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-4" aria-label="Tabs">
                    <Link v-for="tab in tabs" :key="tab.name" :href="tab.href"  :class="[$page.url === tab.href ? 'bg-amaze-coral text-white font-bold' : 'bg-gray-200', 'whitespace-nowrap py-3 px-4 border-b-2 text-sm rounded-t-md']" :aria-current="tab.current ? 'page' : undefined">
                        {{ tab.name }}
                    </Link>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import SettingsLayout from "@/Layouts/SettingsLayout";
import {Link, usePage} from "@inertiajs/vue3";

export default {
    components: {Link},
    computed: {
        tabs: () => usePage().props.quote_tabs ?? null
    }
}
</script>
